import { filterType, isDefined, isString } from '@aloft/toolkit-shared';
import { Block, Flex, Input, Select } from '@aloft/toolkit-sui';

import { DifferenceCriteria, DifferenceCriteriaItem } from '../../matching/types.ts';

export const DefineTheDifference = ({
  criteria,
  setCriteria,
}: {
  criteria: DifferenceCriteria;
  setCriteria: (criteria: DifferenceCriteria) => void;
}) => (
  <Flex gap="20px">
    <DifferenceItem item={criteria.p1} setItem={(p1) => setCriteria({ ...criteria, p1 })} />
    <DifferenceItem item={criteria.p2} setItem={(p2) => setCriteria({ ...criteria, p2 })} />
  </Flex>
);

const DifferenceItem = ({
  item,
  setItem,
}: {
  item: DifferenceCriteriaItem;
  setItem: (item: DifferenceCriteriaItem) => void;
}) => {
  const select = (
    <Select
      size="xs"
      value={item.t}
      onChange={(value) =>
        isDefined(value) ? setItem({ ...item, t: value }) : setItem({ ...item, t: 'any' })
      }
      options={[
        { value: 'any', label: 'None' },
        { value: 'includeKeyword', label: 'Marketing comments must include keyword' },
        { value: 'omitKeyword', label: 'Marketing comments must not include keyword' },
        { value: 'address', label: 'Search for a specific address' },
      ]}
      __dangerDoNotUseSx={{
        backgroundColor: 'textOffset',
      }}
      placeholder=" "
    />
  );

  const input = (item.t === 'includeKeyword' ||
    item.t === 'omitKeyword' ||
    item.t === 'address') && (
    <Input
      type="text"
      value={filterType(isString, item.value)}
      size="xs"
      onChange={(value) => setItem({ ...item, value })}
      onClear={() => setItem({ ...item, value: '' })}
      __dangerDoNotUseSx={{ backgroundColor: 'textOffset' }}
    />
  );

  return (
    <Block>
      {select}
      {input}
    </Block>
  );
};
